export const searchFilters = [
    {
        name: 'Gmail',
        icon: require('../images/accounts-icons/gmail-icon.svg'),
    }, {
        name: 'Slack',
        icon: require('../images/accounts-icons/slack-icon.svg'),
    }, {
        name: 'Microsoft Teams',
        icon: require('../images/accounts-icons/teams.svg'),
    }, {
        name: 'Google Drive',
        platformKey: 'gdrive',
        icon: require('../images/accounts-icons/google-drive-icon.svg')
    }, {
        name: 'Dropbox',
        icon: require('../images/accounts-icons/dropbox-icon.svg'),
    }, {
        name: 'JIRA',
        icon: require('../images/accounts-icons/jira-icon.svg'),
    }, {
        name: 'Outlook',
        icon: require('../images/accounts-icons/outlook-icon.svg')
    }, {
        name: 'Office365',
        platformKey: 'office-365',
        icon: require('../images/accounts-icons/microsoft-365.svg')
    }, {
        name: 'Email',
    }, {
        name: 'Message',
    }, {
        name: 'Link'
    }, {
        name: 'File',
    }, {
        name: 'Show all',
    },
];

export const bookmarksFilters = [
    {
        name: 'Gmail',
        icon: require('../images/accounts-icons/gmail-icon.svg'),
    }, {
        name: 'Slack',
        icon: require('../images/accounts-icons/slack-icon.svg'),
    }, {
        name: 'Microsoft Teams',
        icon: require('../images/accounts-icons/teams.svg'),
    }, {
        name: 'Google Drive',
        icon: require('../images/accounts-icons/google-drive-icon.svg')
    }, {
        name: 'Dropbox',
        icon: require('../images/accounts-icons/dropbox-icon.svg'),
    }, {
        name: 'JIRA',
        icon: require('../images/accounts-icons/jira-icon.svg'),
    }, {
        name: 'Outlook',
        icon: require('../images/accounts-icons/outlook-icon.svg')
    },
    {
        name: 'Show all',
    },
];